import React from "react";
import Popper from "@mui/material/Popper";

const PopperComponent = props => {
  const modifiers = [
    {
      name: "flip",
      options: {
        fallbackPlacements: ["top-start"],
      },
    },
    {
      name: "preventOverflow",
      options: {
        boundary: "viewport",
        padding: 8,
      },
    },
  ];

  return (
    <Popper
      {...props}
      modifiers={modifiers}
      popperOptions={{ placement: "bottom-start" }}
      style={{
        ...props.style,
        maxHeight: "calc(100vh - 100px)",
      }}
    />
  );
};

export default PopperComponent;
